// src/components/profiles/filters/ActiveFiltersDisplay.jsx
import React from 'react';
import {
  Box,
  Chip,
  Typography,
  Stack,
  IconButton,
  Tooltip
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const ActiveFiltersDisplay = ({ filters, onRemove }) => {
  const getFilterLabel = (key, value) => {
    switch (key) {
      case 'gender':
        return value === 'all' ? null : `Gender: ${value}`;
      case 'ageRange':
        return value[0] !== 18 || value[1] !== 60 ? `Age: ${value[0]}-${value[1]}` : null;
      case 'city':
        return value ? `City: ${value}` : null;
      case 'profession':
        return value ? `Profession: ${value}` : null;
      case 'religion':
        return value ? `Religion: ${value}` : null;
      case 'education':
        return value ? `Education: ${value}` : null;
      case 'maritalStatus':
        return value !== 'all' ? `Status: ${value}` : null;
      case 'verified':
        return value ? 'Verified Only' : null;
      case 'sect':
        return value ? `Sect: ${value}` : null;
      case 'caste':
        return value ? `Caste: ${value}` : null;
      case 'familyType':
        return value ? `Family: ${value}` : null;
      case 'familyStatus':
        return value ? `Family Status: ${value}` : null;
      case 'height':
        return value ? `Height: ${value}` : null;
      case 'bodyType':
        return value ? `Body: ${value}` : null;
      case 'incomeRange':
        return value && (value[0] > 0 || value[1] < 500000) 
          ? `Income: ${value[0].toLocaleString()}-${value[1].toLocaleString()} PKR` 
          : null;
      case 'hobbies':
        return value && value.length > 0 ? `Hobbies: ${value.length}` : null;
      case 'languages':
        return value && value.length > 0 ? `Languages: ${value.length}` : null;
      case 'lifestyleHabits':
        return value && value.length > 0 ? `Lifestyle: ${value.length}` : null;
      case 'selfDetails':
        return value.enabled ? 'Your Details Applied' : null;
      default:
        return null;
    }
  };

  const activeFilters = Object.entries(filters)
    .map(([key, value]) => ({
      key,
      label: getFilterLabel(key, value)
    }))
    .filter(filter => filter.label);

  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Active Filters:
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
        {activeFilters.map((filter) => (
          <Chip
            key={filter.key}
            label={filter.label}
            onDelete={() => onRemove(filter.key)}
            deleteIcon={
              <Tooltip title="Remove filter">
                <IconButton size="small">
                  <ClearIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            }
            size="small"
            variant="outlined"
            color="primary"
          />
        ))}
      </Stack>
    </Box>
  );
};

export default ActiveFiltersDisplay;